import { ApiClient } from "@topline/services/apiService";

((module) => {

    module.component('changeProductManager', {
        template: require('./changeProductManagerComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: [ApiClient.componentName, changeProductOwnerComponent]
    });

    function changeProductOwnerComponent(this: $TSFixMe, apiClient: ApiClient) {
        const $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.dataLoading = apiClient.getProductOwnerList()
                .then((data: $TSFixMe) => {
                    const productManagerMsnuId = $ctrl.resolve.productManagerMsnuId;
                    $ctrl.productOwners = data;
                    
                    $ctrl.selectedProductManager = _.find(data, (p: $TSFixMe) => p.msnuId == productManagerMsnuId);
                });

            $ctrl.selectedProductManager = $ctrl.resolve.productManagerMsnuId;
        };
        $ctrl.ok = function () {
            $ctrl.close({ $value: $ctrl.selectedProductManager });
        };

        $ctrl.cancel = function () {
            $ctrl.dismiss({ $value: 'cancel' });
        };
    }


})(angular.module('topline.modules'));
